import { useEffect, useState } from "react";
import { API } from "@/portal/AuthContext";

// Geteilter Cache, damit Banner + Preiskarten nur EINEN Request auf /api/aktionen/aktiv auslösen.
let _cache; // undefined = noch nicht geladen, null = keine Aktion, obj = Aktion
let _promise;

export function aktionGilt(a, code, laufzeit = "monat") {
  return !!(a && (a.laufzeiten || []).includes(laufzeit) && (a.tarife || []).includes(code));
}

export function useAktiveAktion() {
  const [state, setState] = useState(_cache !== undefined ? { aktion: _cache, loading: false } : { aktion: null, loading: true });
  useEffect(() => {
    let alive = true;
    if (_cache !== undefined) { setState({ aktion: _cache, loading: false }); return; }
    if (!_promise) {
      _promise = fetch(`${API}/aktionen/aktiv`, { credentials: "include" })
        .then((r) => r.json())
        .then((d) => { _cache = d.aktion || null; return _cache; })
        .catch(() => { _cache = null; return null; });
    }
    _promise.then((a) => { if (alive) setState({ aktion: a, loading: false }); });
    return () => { alive = false; };
  }, []);
  return state;
}
